module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("BRITISH NAVAL TRAWLERS AND DRIFTERS")])]), _vm._v(" "), _c('h1', {
    staticClass: "title0"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("IN TWO WORLD WARS")])]), _vm._v(" "), _c('p', {
    staticClass: "title01"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FROM THE JOHN LAMBERT COLLECTION")])]), _vm._v(" "), _c('div', {
    staticClass: "img_containert"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p003_01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title01"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Edited and introduced by")])]), _vm._v(" "), _c('p', {
    staticClass: "title01e"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STEVE R DUNN")])]), _vm._v(" "), _c('div', {
    staticClass: "img_containert"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p003_02.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7144114a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Title.vue
// module id = 63
// module chunks = 0